import Immutable from 'seamless-immutable';
// ---- external imports ----

import * as types from './actionTypes';
// ---- local imports ----

const initialState = Immutable({
	id: 0,
	cash: 0,
	hasStartedTurnWithAutoBookkeeper: false,
	gameCompleted: false,
});

export default function reduce(state = initialState, action = {}) {
	switch (action.type) {
	case types.GAME_CREATED_NEW:
	case types.GAME_LOADED:
		return state.merge({
			id: action.gameUser.id,
			cash: parseInt(action.gameUser.cash),
			hasStartedTurnWithAutoBookkeeper: 
				action.gameUser.has_started_turn_with_auto_bookkeeper ?? false,
		});
	case types.GAME_COMPLETED:
		return state.merge({
			gameCompleted: true
		});
	case types.GAME_UPDATE_CASH:
		return state.merge({
			cash: action.updatedCash
		});
	case types.GAME_UPDATE_STARTED_TURN_WITH_AUTO_BOOKKEEPER:
		return state.merge({
			hasStartedTurnWithAutoBookkeeper: action.hasStartedTurnWithAutoBookkeeper ?? false
		});
	default:
		return state;
	}
}
